<template>
  <span class="spara" id="spara-div">
    <button class="saveAsExcel" :class="loadingExcelClass" v-on:click="excelDownload()"
      :disabled="props.isDisabled || disableExcelClass">
      {{ store.texter.searchresultblock.saveasexcel }}
    </button>
    <button class="saveAsCSV" :class="loadingCsvClass" v-on:click="csvDownload()"
      :disabled="props.isDisabled || disableCsvClass">
      {{ store.texter.searchresultblock.saveascsv }}
    </button>
  </span>
</template>
<script setup lang="ts">
import { defineProps, ref } from 'vue';
import useAstaStore from '../stores/AstaStore';
import { downloadFile } from '../Asta/astaService';

const store = useAstaStore();
const props = defineProps<{
  url: string;
  vy: string;
  isDisabled: boolean;
}>();
let loadingExcelClass = ref('');
let disableExcelClass = ref(false);
let loadingCsvClass = ref('');
let disableCsvClass = ref(false);

function excelDownload() {
  loadingExcelClass.value = 'loading';
  disableExcelClass.value = true;
  downloadFile(store.getQueryObject(), 'excel', props.vy, props.url, () => {
    loadingExcelClass.value = '';
    disableExcelClass.value = false;
  });
}

function csvDownload() {
  loadingCsvClass.value = 'loading';
  disableCsvClass.value = true;
  downloadFile(store.getQueryObject(), 'csv', props.vy, props.url, () => {
    loadingCsvClass.value = '';
    disableCsvClass.value = false;
  });
}

</script>
